<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters class="pb-9">
        <v-col class="border--divider"> </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-subheader class="font--text text-body-1 font-weight-medium pa-0" style="height: auto">
            {{ $i18n.t('dialog.body.permissions') }}
          </v-subheader>
        </v-col>
        <v-col cols="12">
          <italic-subheader translation-path="dialog.body.setPermissionsForLayer"> </italic-subheader>
        </v-col>
      </v-row>
      <v-row no-gutters style="min-height: 36px;" class="pt-5">
        <v-spacer> </v-spacer>
        <v-col :cols="isVectorLayer ? 7 : 4" class="border--top" style="background-color: rgba(222, 222, 222, 0.17);">
          <v-row no-gutters>
            <v-col>
              <v-row no-gutters class="justify-center align-center fill-height">
                <v-col cols="auto" class="px-2 py-1">
                  <span class="label">
                    {{ $i18n.t('dialog.body.permissions') }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="isVectorLayer">
              <v-row no-gutters class="justify-center align-center fill-height">
                <v-col cols="auto" class="px-3 py-1">
                  <span class="label">
                    {{ $i18n.t('dialog.body.commentsAndAttachments') }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-2">
            <v-col>
              <v-row no-gutters class="justify-center align-center fill-height">
                <v-col :cols="isVectorLayer ? 9 : 'auto'" class="px-2 py-1">
                  <span class="label" v-if="isVectorLayer">
                    <permissions-select v-model="computedMainValue" />
                  </span>
                  <span class="label" v-else>
                    <v-checkbox
                      class="py-0 my-0 pl-2"
                      @click.native.stop
                      v-model="computedMainValue"
                      :false-value="0"
                      :true-value="1"
                      hide-details
                    ></v-checkbox>
                  </span>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="isVectorLayer">
              <v-row no-gutters class="justify-center align-center fill-height">
                <v-col cols="auto" class="px-3">
                  <span class="label">
                    <v-checkbox
                      class="py-0 my-0 pl-2"
                      @click.native.stop
                      v-model="computedAttachmentsValue"
                      :false-value="0"
                      :true-value="1"
                      hide-details
                      :disabled="value.every(element => element.main_value < 1)"
                    ></v-checkbox>
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-list dense class="pt-0">
            <layer-adding-permissions-list-item
              v-for="(item, index) in computedValue"
              :key="item.group_id"
              v-bind="{ ...item, ...$props }"
              @input="onInput"
              :value="value[index]"
            ></layer-adding-permissions-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import LayerAddingPermissionsListItem from '@/components/LayerAddingPermissionsListItem.vue';
import ItalicSubheader from '@/components/ItalicSubheader';
import PermissionsSelect from '@/components/PermissionsSelect';

export default {
  name: 'LayerAddingPermissions',
  components: { ItalicSubheader, LayerAddingPermissionsListItem, PermissionsSelect },
  props: {
    value: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    isVectorLayer() {
      return this.type === 'features_layer';
    },
    computedValue: {
      get() {
        const groups = this.value;
        return groups.sort((a, b) => b.group_id - a.group_id);
      },
      set(nV) {
        console.log(nV);
        this.$emit('input', nV);
      },
    },
    computedAttachmentsValue: {
      get() {
        return this.value.findIndex(element => element.attachments_and_comments_value === 0) < 0 ? 1 : 0;
      },
      set(v) {
        this.$emit('attachmentsInput', v);
      },
    },
    computedMainValue: {
      get() {
        if (this.value.every(element => element.main_value === 2)) {
          return 2;
        } else if (this.value.every(element => element.main_value === 1)) {
          return 1;
        } else if (this.value.every(element => element.main_value === 0)) {
          return 0;
        } else {
          return null;
        }
      },
      set(v) {
        this.$emit('mainInput', v);
      },
    },
    permissionTypeComponent() {
      return this.permission_type === 'two_level' ? 'PermissionsCheckbox' : 'PermissionsSelect';
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panels {
  border-radius: 0;
}
.v-expansion-panel,
.border--top {
  @include border(right);
  @include border(left);
}
.border--top {
  border-radius: 6px 6px 0 0;
  @include border(top);
}
.label {
  font-size: 12px;
  line-height: 14px !important;
}
::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}
.border {
  @include border(top);
  @include border(left);
  @include border(right);
  &:last-child {
    @include border(bottom);
  }
}
.border--divider {
  @include border(top);
}
</style>
